import { Platform } from 'react-native';

// Import images for web
import kartaImg from '@/assets/gifts/karta.png';
import gpayImg from '@/assets/gifts/gpay.png';
import applepayImg from '@/assets/gifts/applepay.png';
import blikImg from '@/assets/gifts/blik.png';

// Helper to get image source compatible with both platforms
const getImageSource = (webImage: string) => {
  if (Platform.OS === 'web') {
    return { uri: webImage };
  }
  return webImage as any;
};

// Types
export type Transaction = {
  id: string;
  title: string;
  date: string;
  amount: number;
  type: 'income' | 'expense';
  avatar: string;
};

export type PresetAmount = {
  amount: number;
  label: string;
};

export type PaymentMethod = {
  id: string;
  name: string;
  description: string;
  icon: any;
};

// Mock Data
export const PRESET_AMOUNTS: PresetAmount[] = [
  { amount: 50, label: 'Podstawowa' },
  { amount: 100, label: 'Popularna' },
  { amount: 250, label: 'Optymalna' },
  { amount: 500, label: 'Premium' },
];

export const MOCK_TRANSACTIONS: Transaction[] = [
  {
    id: '1',
    title: 'Spotkanie przy kawie',
    date: 'Dziś 18:32',
    amount: -150.55,
    type: 'expense',
    avatar: 'https://i.pravatar.cc/150?img=1',
  },
  {
    id: '2',
    title: 'Wspólne zakupy',
    date: 'Dziś 12:32',
    amount: 1150.55,
    type: 'income',
    avatar: 'https://i.pravatar.cc/150?img=2',
  },
  {
    id: '3',
    title: 'Męska rozmowa przy piwie',
    date: 'Cze 24 13:53',
    amount: -75.00,
    type: 'expense',
    avatar: 'https://i.pravatar.cc/150?img=3',
  },
  {
    id: '4',
    title: 'Wspólny meczyk',
    date: 'Maj 28 13:53',
    amount: -55.00,
    type: 'expense',
    avatar: 'https://i.pravatar.cc/150?img=4',
  },
  {
    id: '5',
    title: 'Trening personalny',
    date: 'Maj 24 13:53',
    amount: -55.00,
    type: 'expense',
    avatar: 'https://i.pravatar.cc/150?img=5',
  },
  {
    id: '6',
    title: 'Wspólne zakupy',
    date: 'Dziś 12:32',
    amount: 1150.55,
    type: 'income',
    avatar: 'https://i.pravatar.cc/150?img=6',
  },
  {
    id: '7',
    title: 'Męska rozmowa przy piwie',
    date: 'Cze 24 13:53',
    amount: -75.00,
    type: 'expense',
    avatar: 'https://i.pravatar.cc/150?img=7',
  },
];

export const PAYMENT_METHODS: PaymentMethod[] = [
  { 
    id: 'card', 
    name: 'Karta płatnicza', 
    description: 'Visa, Mastercard', 
    icon: getImageSource(kartaImg)
  },
  { 
    id: 'google', 
    name: 'Google Pay', 
    description: 'Szybka płatność', 
    icon: getImageSource(gpayImg)
  },
  { 
    id: 'apple', 
    name: 'Apple Pay', 
    description: 'Szybka płatność', 
    icon: getImageSource(applepayImg)
  },
  { 
    id: 'blik', 
    name: 'BLIK', 
    description: 'Kod z aplikacji', 
    icon: getImageSource(blikImg)
  },
];


